export { default as EncountersInfoTooltip } from './EncountersInfoTooltip';
